/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Enrollment effort tiers to keep; plans whose tier is UNKNOWN or missing pass any selection
 */
export enum FilterableEnrollmentEffortTier {
  EASY_ENROLL = 'EASY_ENROLL',
  EXTRA_STEPS = 'EXTRA_STEPS',
  SELF_ENROLL = 'SELF_ENROLL',
}
